{
  "scheduling": "சந்திப்புத் திட்டமிடல்",
  "date": "தேதி",
  "time": "நேரம்",
  "duration": "காலம்",
  "provider": "மருத்துவர்",
  "reason": "காரணம்",
  "status": "நிலை",
  "statusOptions": {
    "scheduled": "திட்டமிடப்பட்டது",
    "confirmed": "உறுதிப்படுத்தப்பட்டது",
    "arrived": "வந்துள்ளார்",
    "checked-in": "வந்து சேர்ந்தார்",
    "in-progress": "நடைபெறுகிறது",
    "completed": "முடிக்கப்பட்டது",
    "cancelled": "ரத்து செய்யப்பட்டது",
    "no-show": "வரவில்லை"
  },
  "coverageScope": {
    "panel": "நோயாளி குழு",
    "unit": "பிரிவு",
    "facility": "முழு மருத்துவ நிலையம்"
  },
  "coverageScopeDescription": {
    "panel": "காப்பீடு செய்யப்படும் மருத்துவரின் நோயாளி குழுவிற்கு மட்டும்.",
    "unit": "காப்பீடு செய்யப்படும் மருத்துவருக்கு ஒதுக்கப்பட்ட பிரிவு.",
    "facility": "முழு மருத்துவ நிலையம் — பொதுவாக ஆன்-கால் ஏற்பாடுகள்."
  },
  "dayShort": {
    "0": "ஞா",
    "1": "தி",
    "2": "செ",
    "3": "பு",
    "4": "வி",
    "5": "வெ",
    "6": "ச"
  },
  "blockType": {
    "available": "கிடைக்கிறது",
    "blocked": "தடுக்கப்பட்டது"
  },
  "appointmentTypes": {
    "followUp": "தொடர் சோதனை",
    "newPatient": "புதிய நோயாளி",
    "consultation": "ஆலோசனை",
    "procedure": "செயல்முறை",
    "urgent": "அவசரம்",
    "wellnessCheck": "ஆரோக்கிய சோதனை",
    "physical": "உடல் பரிசோதனை",
    "telemedicine": "தொலை மருத்துவம்",
    "scheduleTemplate": "அட்டவணை வார்ப்புரு"
  },
  "pages": {
    "providerDirectory": {
      "title": "மருத்துவர் அடைவு",
      "subtitle": "சுகாதார சேவை வழங்குநர்களை உலாவி தேடவும்",
      "search": {
        "namePlaceholder": "பெயரால் தேடவும்...",
        "specialtyPlaceholder": "சிறப்புத் துறையால் தேடவும்..."
      },
      "filters": {
        "facilityAriaLabel": "மருத்துவ நிலையம் வாரியாக வடிகட்டவும்",
        "departmentAriaLabel": "துறை வாரியாக வடிகட்டவும்",
        "allFacilities": "அனைத்து மருத்துவ நிலையங்கள்",
        "allDepartments": "அனைத்து துறைகள்"
      },
      "loading": "மருத்துவர்கள் ஏற்றப்படுகிறது...",
      "loadError": "மருத்துவர் அடைவை ஏற்ற முடியவில்லை.",
      "empty": "உங்கள் அளவுகோல்களுக்கு ஏற்ற மருத்துவர் இல்லை.",
      "npiLabel": "NPI:"
    },
    "scheduleTemplateForm": {
      "title": "அட்டவணை வார்ப்புருவை உருவாக்கு",
      "labels": {
        "provider": "மருத்துவர்",
        "dayOfWeek": "வாரத்தின் நாள்",
        "startTime": "தொடக்க நேரம்",
        "endTime": "முடிவு நேரம்",
        "slotDuration": "கால அளவு (நிமிடம்)",
        "templateName": "வார்ப்புரு பெயர்",
        "effectiveStartDate": "அமலுக்கு வரும் தேதி"
      },
      "slotDurationOption": "{{minutes}} நிமிடம்",
      "buttons": {
        "cancel": "ரத்து",
        "save": "வார்ப்புருவை சேமி"
      },
      "toast": {
        "success": "அட்டவணை வார்ப்புரு சேமிக்கப்பட்டது",
        "failure": "அட்டவணை வார்ப்புருவை சேமிக்க முடியவில்லை"
      },
      "placeholders": {
        "templateName": "எ.கா. திங்கள் காலை மருத்துவமனை"
      },
      "defaultName": "{{day}} அட்டவணை"
    },
    "scheduleManagement": {
      "title": "அட்டவணை மேலாண்மை",
      "backToDashboard": "← டாஷ்போர்டு",
      "newTemplate": "புதிய வார்ப்புரு",
      "today": "இன்று",
      "blockTooltip": "{{start}} - {{end}} ({{state}})",
      "slotsLabel": "{{minutes}} நிமிட இடைவெளி",
      "legend": {
        "booked": "முன்பதிவு செய்யப்பட்டது"
      },
      "upcomingAppointmentsHeading": "வரவிருக்கும் சந்திப்புகள் - {{providerName}}",
      "loadingAppointments": "சந்திப்புகள் ஏற்றப்படுகிறது...",
      "unknownPatient": "தெரியாத நோயாளர்",
      "fallbackAppointmentType": "பொது",
      "noUpcomingAppointments": "இந்த மருத்துவருக்கு வரவிருக்கும் சந்திப்புகள் இல்லை"
    },
    "providerCoverage": {
      "title": "மருத்துவர் காப்பீடு",
      "subtitle": "காலக்கெடு கொண்ட பணிக்காப்பீடு — குறிப்பிட்ட காலத்திற்கு உங்கள் நோயாளி குழுவை சக ஊழியரிடம் ஒப்படைக்கவும். அவசர அணுகலிலிருந்து வேறுபட்டது; விடுமுறை, ஆன்-கால் சுழற்சி, திட்டமிட்ட இல்லாமைக்கு பயன்படுகிறது.",
      "actions": {
        "newCoverage": "புதிய காப்பீடு",
        "cancel": "ரத்து செய்"
      },
      "form": {
        "title": "புதிய காப்பீட்டு ஏற்பாடு",
        "labels": {
          "coveredProviderId": "காப்பீடு செய்யப்படும் மருத்துவர்",
          "coveringProviderId": "காப்பீடு செய்யும் மருத்துவர்",
          "scope": "வரம்பு",
          "from": "முதல்",
          "until": "வரை",
          "reason": "காரணம்"
        },
        "placeholders": {
          "coveredProviderId": "எவருடைய நோயாளி குழு பராமரிக்கப்படுகிறதோ அந்த மருத்துவர்",
          "coveringProviderId": "இந்த காலத்திற்கு பொறுப்பேற்கும் மருத்துவர்",
          "reason": "எ.கா. ஏப்ரல் 22–29 ஆண்டு விடுமுறை; வார இறுதி ஆன்-கால் காப்பீடு"
        },
        "help": {
          "coveredProviderId": "COVERAGE_ADMIN இல்லாமல், இது நீங்களாகவே இருக்க வேண்டும்.",
          "coveringProviderId": "பெயரால் தேடித் தேர்ந்தெடுக்கவும் — தட்டச்சு செய்த ஐடிக்கு ஒருபோதும் காப்பீடு வழங்கப்படாது."
        },
        "aria": {
          "effectiveFromDate": "செயலில் வரும் தேதி",
          "effectiveFromTime": "செயலில் வரும் நேரம்",
          "effectiveUntilDate": "செயலில் முடியும் தேதி",
          "effectiveUntilTime": "செயலில் முடியும் நேரம்"
        },
        "buttons": {
          "cancel": "ரத்து செய்",
          "create": "காப்பீடு உருவாக்கு"
        },
        "typeaheadEmpty": "மருத்துவர்கள் யாரும் கிடைக்கவில்லை"
      },
      "sections": {
        "mine": {
          "title": "என் காப்பீடு",
          "subtitle": "நான் காப்பீடு செய்பவர் அல்லது காப்பீடு செய்யப்படுபவராக இருக்கும் காப்பீடுகள்.",
          "empty": "பதிவில் எந்த காப்பீடும் இல்லை."
        },
        "all": {
          "title": "அனைத்து காப்பீடுகள்",
          "subtitle": "நிறுவனத்தில் உள்ள ஒவ்வொரு காப்பீட்டு ஏற்பாடும். நிர்வாகி காட்சி.",
          "empty": "எங்கும் காப்பீடு இல்லை. அது மிகவும் நல்ல செய்தி அல்லது பழைய வடிகட்டி."
        }
      },
      "list": {
        "coveringConnector": "காப்பீடு செய்கிறார்",
        "groups": {
          "active": "செயலில் ({{count}})",
          "planned": "திட்டமிட்ட / கடந்த ({{count}})",
          "revoked": "ரத்தாக்கப்பட்டது ({{count}})"
        },
        "untilRevoked": "ரத்தாகும் வரை",
        "revokedPrefix": "ரத்தாக்கப்பட்டது",
        "revokeTitle": "ரத்தாக்கு"
      },
      "revokeDialog": {
        "title": "காப்பீட்டை ரத்தாக்க வேண்டுமா?",
        "description": "{{coveringProviderName}} இனி {{coveredProviderName}} ஐ காப்பீடு செய்ய மாட்டார். பதிவு தணிக்கைத் தடத்தில் இருக்கும்.",
        "confirm": "ரத்தாக்கு",
        "reasonPlaceholder": "இந்தப் பாதுகாப்பு ஏன் முடிவடைகிறது? (விருப்பம்)"
      },
      "toast": {
        "created": "காப்பீடு உருவாக்கப்பட்டது",
        "revoked": "காப்பீடு ரத்தாக்கப்பட்டது",
        "invalid": "தவறான காப்பீடு — மருத்துவர்கள் மற்றும் தேதிகளைச் சரிபார்க்கவும்",
        "forbidden": "இந்த மருத்துவருக்கான காப்பீட்டை உருவாக்க அனுமதி இல்லை",
        "createFailed": "காப்பீடு உருவாக்க முடியவில்லை",
        "revokeFailed": "காப்பீடு ரத்தாக்க முடியவில்லை"
      }
    },
    "appointments": {
      "title": "சந்திப்புகள்",
      "subtitle": "நோயாளி சந்திப்புகளை திட்டமிட்டு நிர்வகிக்கவும்",
      "actions": {
        "refresh": "புதுப்பிக்கவும்",
        "schedule": "சந்திப்பை திட்டமிடவும்",
        "arriveTitle": "வருகையைப் பதிவு செய்",
        "arriveAria": "{{patientName}} வருகையைப் பதிவு செய்",
        "checkInTitle": "வந்து சேர்க",
        "checkInAria": "{{patientName}} வந்து சேர்க",
        "rescheduleTitle": "மீண்டும் திட்டமிடவும்",
        "rescheduleAria": "{{patientName}} மீண்டும் திட்டமிடவும்",
        "cancelTitle": "ரத்து",
        "cancelAria": "{{patientName}} சந்திப்பை ரத்து செய்க",
        "checkedInLabel": "வந்து சேர்ந்தார்",
        "startVisitTitle": "பரிசோதனையைத் தொடங்கு",
        "startVisitAria": "{{patientName}} க்கான பரிசோதனையைத் தொடங்கு"
      },
      "weekNav": {
        "previous": "முந்தைய வாரம்",
        "previousAria": "முந்தைய வாரம்",
        "next": "அடுத்த வாரம்",
        "nextAria": "அடுத்த வாரம்"
      },
      "calendar": {
        "gridAria": "வாராந்திர சந்திப்பு நாட்காட்டி",
        "timeColumn": "நேரம்",
        "loading": "அட்டவணையை ஏற்றுகிறது...",
        "cellAria": "{{dayLabel}} {{date}} {{time}} மணிக்கு",
        "cellTitle": "{{patientName}} - {{appointmentType}} ({{status}})"
      },
      "upcoming": {
        "heading": "வரவிருக்கும் சந்திப்புகள்",
        "empty": "இந்த வாரத்தில் சந்திப்புகள் இல்லை",
        "durationMinutes": "{{minutes}} நிமிடம்",
        "columns": {
          "dateTime": "தேதி / நேரம்",
          "patient": "நோயாளி",
          "type": "வகை",
          "provider": "மருத்துவர்",
          "duration": "காலம்",
          "status": "நிலை",
          "actions": "செயல்கள்"
        }
      },
      "toast": {
        "cancelled": "சந்திப்பு ரத்து செய்யப்பட்டது",
        "cancelFailed": "சந்திப்பை ரத்து செய்ய முடியவில்லை",
        "visitStarted": "பரிசோதனை தொடங்கியது",
        "startVisitFailed": "பரிசோதனையைத் தொடங்க முடியவில்லை",
        "arrivalRecorded": "வருகை பதிவு செய்யப்பட்டது",
        "arrivalFailed": "வருகையைப் பதிவு செய்ய முடியவில்லை"
      }
    },
    "appointmentForm": {
      "title": {
        "create": "புதிய சந்திப்பை திட்டமிடுக",
        "edit": "சந்திப்பை மறுசீரமைக்கவும்"
      },
      "labels": {
        "patient": "நோயாளி",
        "appointmentType": "சந்திப்பு வகை",
        "provider": "மருத்துவர்",
        "scheduledAt": "திட்டமிட்ட நேரம்",
        "duration": "காலஅளவு",
        "reason": "வருகை காரணம்"
      },
      "placeholders": {
        "patientSearch": "பெயர் அல்லது MRN மூலம் நோயாளியைத் தேடுக...",
        "provider": "மருத்துவர் பெயர்",
        "reason": "வருகைக்கான சுருக்கமான காரணம்..."
      },
      "patientTypeahead": {
        "empty": "நோயாளிகள் இல்லை"
      },
      "aria": {
        "appointmentDate": "சந்திப்பு தேதி",
        "appointmentTime": "சந்திப்பு நேரம்"
      },
      "durationOption": "{{minutes}} நிமி",
      "buttons": {
        "cancel": "ரத்து",
        "schedule": "சந்திப்பை திட்டமிடுக",
        "update": "சந்திப்பை புதுப்பிக்க"
      },
      "toast": {
        "created": "சந்திப்பு வெற்றிகரமாக திட்டமிடப்பட்டது",
        "updated": "சந்திப்பு புதுப்பிக்கப்பட்டது",
        "createFailed": "சந்திப்பை உருவாக்க முடியவில்லை",
        "updateFailed": "சந்திப்பை புதுப்பிக்க முடியவில்லை"
      },
      "validation": {
        "patientRequired": "ஒரு நோயாளியை தேர்ந்தெடுக்கவும்",
        "appointmentTypeRequired": "சந்திப்பு வகை தேவை",
        "scheduledAtRequired": "தேதி மற்றும் நேரம் தேவை",
        "durationInvalid": "கால அளவு 1 முதல் 480 நிமிடங்களுக்குள் இருக்க வேண்டும்",
        "providerRequired": "ஒரு மருத்துவரை தேர்ந்தெடுக்கவும்"
      },
      "providerTypeahead": {
        "empty": "மருத்துவர்கள் யாரும் கிடைக்கவில்லை"
      },
      "loadingEdit": "நியமனம் ஏற்றப்படுகிறது…",
      "loadEditError": "இந்த நியமனத்தை ஏற்ற முடியவில்லை.",
      "patientLocked": "மறு நியமனத்தின்போது நோயாளரை மாற்ற முடியாது."
    },
    "waitlist": {
      "title": "சந்திப்புக் காத்திருப்புப் பட்டியல்",
      "backToDashboard": "← டாஷ்போர்டு",
      "entryCount": "{{count}} உள்ளீடுகள்",
      "searchPlaceholder": "நோயாளியின் பெயர், MRN அல்லது குறிப்புகளைத் தேடுக...",
      "clearSearchAria": "தேடலை அழி",
      "filters": {
        "allProviders": "அனைத்து மருத்துவர்களும்",
        "allTypes": "அனைத்து வகைகளும்",
        "providerAriaLabel": "மருத்துவர் வாரியாக வடிகட்டு",
        "typeAriaLabel": "சந்திப்பு வகையால் வடிகட்டு"
      },
      "columns": {
        "patient": "நோயாளி",
        "provider": "மருத்துவர்",
        "type": "வகை",
        "priority": "முன்னுரிமை",
        "requestedDates": "கோரப்பட்ட தேதிகள்",
        "dateAdded": "சேர்க்கப்பட்ட தேதி",
        "notes": "குறிப்புகள்",
        "actions": "செயல்கள்",
        "reason": "காரணம்"
      },
      "priority": {
        "urgent": "அவசரம்",
        "routine": "வழக்கமான",
        "flexible": "நெகிழ்வான"
      },
      "actions": {
        "scheduleTitle": "சந்திப்பை திட்டமிடுக",
        "editPriorityTitle": "முன்னுரிமையை திருத்துக",
        "removeTitle": "காத்திருப்புப் பட்டியலிலிருந்து நீக்கு"
      },
      "empty": "உங்கள் வடிகட்டிகளுக்கு பொருந்தும் காத்திருப்புப் பட்டியல் உள்ளீடுகள் இல்லை",
      "loadFailed": "காத்திருப்புப் பட்டியலை ஏற்ற முடியவில்லை. உங்கள் இணைப்பைச் சரிபார்த்து மீண்டும் முயலவும்.",
      "modal": {
        "title": "சந்திப்பை திட்டமிடுக",
        "closeAria": "மூடு",
        "providerLabel": "மருத்துவர்:",
        "requestedLabel": "கோரிக்கை:",
        "dateTimeLabel": "சந்திப்பு தேதி மற்றும் நேரம் *",
        "dateAria": "சந்திப்பு தேதி",
        "timeAria": "சந்திப்பு நேரம்",
        "requestedWindow": "கோரப்பட்ட காலம்: {{start}} — {{end}}",
        "cancel": "ரத்து செய்",
        "submit": "திட்டமிடு"
      },
      "toasts": {
        "removed": "உள்ளீடு காத்திருப்புப் பட்டியலிலிருந்து நீக்கப்பட்டது",
        "priorityUpdated": "முன்னுரிமை புதுப்பிக்கப்பட்டது",
        "scheduled": "சந்திப்பு திட்டமிடப்பட்டு காத்திருப்புப் பட்டியலிலிருந்து நீக்கப்பட்டது",
        "dateTimeRequired": "தயவுசெய்து தேதி மற்றும் நேரத்தைத் தேர்ந்தெடுக்கவும்",
        "updateFailed": "காத்திருப்புப் பட்டியலைப் புதுப்பிக்க முடியவில்லை",
        "promoteOrphaned": "நியமனம் உருவாக்கப்பட்டது, ஆனால் காத்திருப்புப் பட்டியல் உள்ளீட்டைப் புதுப்பிக்க முடியவில்லை. மீண்டும் முயலும் முன் அட்டவணையைச் சரிபார்க்கவும்."
      }
    },
    "checkIn": {
      "title": "நோயாளியைப் பதிவு செய்",
      "subtitle": "பதிவு — காப்பீடு, அனுமதி மற்றும் இணைக்கட்டணம். நோயாளி வந்துவிட்டார்.",
      "fields": {
        "insuranceId": "காப்பீடு",
        "copayAmount": "இணைக்கட்டணத் தொகை",
        "copayCollected": "இணைக்கட்டணம் பெறப்பட்டது",
        "authorizationNumber": "அனுமதி எண்",
        "authorizationVerified": "அனுமதி சரிபார்க்கப்பட்டது"
      },
      "copayHint": "இணைக்கட்டணம் பெறப்பட்டதாகக் குறித்தால் நோயாளியின் கணக்கில் கட்டணம் பதிவாகும்.",
      "submit": "பதிவை முடிக்கவும்",
      "cancel": "ரத்து",
      "toast": {
        "success": "நோயாளி பதிவு செய்யப்பட்டார்",
        "failed": "நோயாளியைப் பதிவு செய்ய முடியவில்லை"
      }
    },
    "providerTypeahead": {
      "loadError": "மருத்துவர் அடைவு கிடைக்கவில்லை — இணைப்பைச் சரிபார்த்து மீண்டும் முயல்க.",
      "retry": "மீண்டும் முயல்க"
    }
  }
}
